<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Propira Testimonials & Reviews</h1>
        </div>
    </div>
</div>

<div class="col-md-12 breaeea">

    <ul class="breadcrumb">
        <li><a routerLink="/">Home</a></li>
         <li>Testimonials</li>
    </ul>

</div>

<div class="container-fluid paddEqual testimonial-page">
    <div class="container">
        <div class="row">
            <div class="col-md-10 col-12 offset-md-1" *ngIf="testimonialList.length>0">
                <div class="row rowLeftM">
                    <div class="col-12">
                        <figure class="testimonial" *ngFor="let testimonial of testimonialList">
                            <blockquote>{{testimonial.description}}
                                <div class="arrow"></div>
                            </blockquote>
                            <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{testimonial.image}}" alt="image-1" />
                            <div class="user">
                                <h3>{{testimonial.client_name | titlecase}}</h3>
                                <p class="identify">{{testimonial.designation | titlecase }}</p>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="testimonialList.length==0">
                <p style="color:red">No Record Found.</p>
            </div>
        </div>
    </div>
</div>